import { useRef, useState } from 'react';
import { Image } from 'lucide-react';
import { NButton, NInput, NTextarea, useToast } from 'nayan';
import { useUpdateUserMutation } from '@/shared/services/UsersService';
import { extendFormData, getFileName } from '@/shared/services/Utils.ts';
import { useUserStore } from '@/shared/stores/UserStore';
import { getUsersUrl, resizeImage } from '@/ui/services/WebUtils.ts';

interface Props {
  onClose: any;
}

export const AccountProfileEdit = (props: Props) => {
  const toast = useToast();
  const inputImageRef = useRef<any>(null);
  const user = useUserStore(state => state);
  const [myFile, setFile] = useState<any>('');
  const [name, setName] = useState(user.UNAME || '');
  const [mobile, setMobile] = useState(user.UMOBILE || '');
  const [dob, setDob] = useState(user.UDOB || '');
  const [about, setAbout] = useState(user.UABOUT || '');
  const updateUserMutation = useUpdateUserMutation();

  const onSubmit = async (e: any) => {
    e.preventDefault();
    if (!name || name?.length <= 3) {
      toast('Name should not empty and minimum of 3 characters.');
    } else if (mobile && mobile.length !== 10) {
      toast('Mobile number should be a valid 10 digit number.');
    } else {
      const finalUser = Object.assign({}, { uuid: user.UUID, name, mobile, about, dob }, !!myFile ? { file: getFileName(myFile.name) } : {});
      const formData = new FormData();
      if (myFile) {
        const resizeImg: any = await resizeImage(myFile, 200, 200);
        const res = await fetch(resizeImg); // fetch converts base64 to a Blob
        const blob = await res.blob();
        formData.append('myFile', blob, myFile.name);
      }
      extendFormData(formData, finalUser);
      updateUserMutation
        .mutateAsync({ uuid: finalUser.uuid, formData })
        .then(() => {
          toast('User info updated successfully.');
          props.onClose();
        })
        .catch(e => toast(e.message));
    }
  };

  const getTempFile = () => {
    return URL.createObjectURL(myFile);
  };

  return (
    <div className="p-3">
      <form onSubmit={onSubmit}>
        <div className="profile-edit-image flex items-center mb-5">
          <img className="image-container w-[80px] h-[80px] rounded-full mr-3" src={!!myFile ? getTempFile() : getUsersUrl(user.UFILE)} alt="" />
          <div>
            <div>
              <input type="file" className="myFile hidden" accept="image/*" ref={inputImageRef} onChange={(e: any) => setFile(e.target.files[0])} />
              <span className="add-post-btn cursor-pointer flex items-center" onClick={() => inputImageRef.current && inputImageRef.current.click()}>
                <Image className="w-5 h-5 text-primary" />
                <span className="pl-2 text-primary"> Change profile picture</span>
              </span>
            </div>
            <div className="text-muted text-xs mt-1">Select new image to change your profile picture.</div>
          </div>
        </div>
        <NInput label="Name" name="name" value={name} onChange={e => setName(e.target.value)} />
        <NInput label="Mobile" name="mobile" value={mobile} onChange={e => setMobile(e.target.value)} />
        <NInput type="date" name="dob" label="Date of birth" value={dob} onChange={e => setDob(e.target.value)} />
        <NTextarea name="about" className="mb-3" label="About" value={about} onChange={e => setAbout(e.target.value)} />
        <NButton type="submit">Update</NButton>
      </form>
    </div>
  );
};
